import React from 'react';
import PropTypes from 'prop-types';
import cn from 'src/classnames';
import Button from '@mui/material/Button';
import styles from './TextButton.module.scss';

const TextButton = ({ children, className, onClick, startIcon, endIcon, textView, disabled, classes }) => {
  return (
    <Button
      className={cn(styles.button, className, { [styles.regularText]: startIcon || textView })}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      classes={{ ...classes, startIcon: styles.startIcon }}
    >
      {children}
    </Button>
  );
};

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  startIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.number]),
  endIcon: PropTypes.element,
  textView: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
};

TextButton.defaultProps = {
  className: '',
  startIcon: null,
  endIcon: null,
  textView: false,
  disabled: false,
  onClick: () => {},
  classes: {},
};

export default TextButton;
